import { render } from "./uiFullscreenImage.vue?vue&type=template&id=690b0756"
import script from "./uiFullscreenImage.vue?vue&type=script&lang=js"
export * from "./uiFullscreenImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__